import React,{useState,useEffect } from 'react';
import {currentDateFormat} from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import VehicleMaintenanceTable from '../components/tables/VehicleMaintenanceTable';
import { MAINTENANCE_VEHICLE_REPORT  } from '../constant';
import axios from 'axios';
import moment from 'moment';

function VehicleMaintenanceList() {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const [currentDate,setCurrentDate] = useState(new Date());
    const [maintenanceVehicle, setMaintenanceVehicle] = useState([]);
    
    useEffect(() => {
      const fetchMaintenanceData = async () => {
        try {
          dispatch(setLoading(true));
          const response = await axios.get(MAINTENANCE_VEHICLE_REPORT );
          console.log("response",response.data.data);
          if (response.data && response.data.data) {
            const questionlist = response.data.data.questionsList;
            
            const groupedByVehicle = {};

            response.data.data.result.forEach(vehicle => {
              const vehicleId = vehicle.vehicle_id;
              // Parse ISO 8601 date format (remove quotes if present)
              const dateString = vehicle.inspection_date.replace(/"/g, '');
              const currentDate = moment.utc(dateString);

              // Keep the latest inspection per vehicle using moment (handles same date with different times)
              if (
                !groupedByVehicle[vehicleId] ||
                currentDate.isAfter(moment.utc(groupedByVehicle[vehicleId].inspection_date.replace(/"/g, '')))
              ) {
                groupedByVehicle[vehicleId] = vehicle;
                console.log(`Updated vehicle ${vehicleId} with driver ${vehicle.driverDetails?.driver_full_name} at ${currentDate.format('YYYY-MM-DD HH:mm:ss')}`);
              } else {
                console.log(`Skipped vehicle ${vehicleId} with driver ${vehicle.driverDetails?.driver_full_name} at ${currentDate.format('YYYY-MM-DD HH:mm:ss')} (older than existing)`);
              }
            });

            const vehiclesNeedingMaintenance = Object.values(groupedByVehicle)
              .map(vehicle => {
                let components;

                try {
                  const parsedOnce = JSON.parse(vehicle?.component);
                  components = typeof parsedOnce === 'string'
                    ? JSON.parse(parsedOnce)
                    : parsedOnce;
                } catch (err) {
                  console.error('Failed to parse component JSON for vehicle', vehicle.vehicle_id, ':', vehicle.component);
                  return null;
                }

                const failedComponents = components.filter(
                  c => c.answer == '2' || c.answer == '3'
                );

                if (failedComponents.length > 0) {
                  return {
                    driver_name: vehicle.driverDetails?.driver_full_name,
                    driver_id: vehicle.driver_id,
                    vehicle_name: vehicle.vehicleDetails?.vehicle_name,
                    vehicle_id: vehicle.vehicle_id,
                    last_update_date: vehicle.inspection_date,
                    questions: failedComponents.map(c => ({
                      question: questionlist[c.questionId - 1] || c.questionId,
                      status: c.answer == '2' ? 'Requires Attention' : 'Needs Repair'
                    }))
                  };
                }

                return null; // Skip vehicles with no failed components
              })
              .filter(Boolean).sort((a, b) =>
                moment.utc(b.last_update_date.replace(/"/g, '')).diff(
                  moment.utc(a.last_update_date.replace(/"/g, ''))
                )
              );

            setMaintenanceVehicle(vehiclesNeedingMaintenance);
          }
        } catch (error) {
          console.error('Error fetching maintenance data:', error);
        } finally {
          dispatch(setLoading(false));
        }
      };

      fetchMaintenanceData();
    }, [dispatch]);
  return (
        <><section>

      <div className='d-flex justify-content-between form-container'>
        <div>
          <h2 className="fs-5 font-weight-600">Vehicle Maintenance List   </h2>
        </div>
        <div>
          <span>{currentDateFormat(currentDate)}</span>
        </div>
      </div>
    </section>      
    <section>
        <div>
          <VehicleMaintenanceTable maintenanceVehicle={maintenanceVehicle} />
        </div>
      </section></>
    
  )
}

export default VehicleMaintenanceList